<template>
  <v-app>
    <v-toolbar color="white" elevation="1">
      <v-row justify="space-between" class="logo-alignment fullHeight pt-3">
        <img
          :src="icon"
          class="fullHeight contain"
          @click.stop.prevent="logout"
        />
        <h2 class="time pb-2">{{ time }}</h2>
        <div class="weather">
          <h4 :style="{ color: '#212121', 'font-size': '24px' }">
            {{ weather.temp }}&#176;
          </h4>
          <v-img
            :src="weather.icon"
            max-height="44"
            max-width="44"
            class="px-2 mb-1"
          />
        </div>
      </v-row>
    </v-toolbar>
    <v-content class="full_height mx-0 main_content">
      <display ref="display"></display>
    </v-content>
  </v-app>
</template>

<script>
import moment from "moment-timezone";
export default {
  name: "App",
  data() {
    return {
      icon: require("./assets/logo.png"),
      time: moment.tz(moment.now(), "America/Montreal").format("hh:mm A"),
    };
  },
  computed: {
    weather() {
      return this.$store.getters["getWeather"];
    },
    c_userId() {
      return this.$store.getters["userId"];
    },
    c_token() {
      return this.$store.getters["token"];
    },
  },
  methods: {
    async getWeatherData() {
      const self = this;
      const { data } = await self.$axios.get("/getWeatherData");
      self.$store.dispatch("updateWeather", data);
    },
    async logout() {
      if (this.c_userId) {
        this.$store.dispatch("setUserId", undefined);
        this.$store.dispatch("setToken", undefined);
        window.localStorage.removeItem("easy1");
        this.$store.dispatch("unsubscribe");
        const { data } = await this.$axios({
          method: "get",
          url: "/user/logout",
          data: { _id: this.c_userId },
        });
      }
    },
  },
  mounted() {
    this.$store.dispatch("initialize");
    var name = "easy1Cookie" + "=";

    var data = JSON.parse(window.localStorage.getItem("easy1"));
    if (data) {
      this.$store.dispatch("setUserId", data.user_id);
      this.$store.dispatch("setToken", data.Authorization);
      this.$store.dispatch("setCompany", data.company);
    }
    this.$store.dispatch("initialize");

    this.getWeatherData();
    setInterval(() => {
      this.getWeatherData();
    }, 600000);
    setInterval(() => {
      location.reload();
    }, 43200000);
    setInterval(() => {
      this.time = moment.tz(moment.now(), "America/Montreal").format("hh:mm A");
    }, 60000);
  },
  watch: {
    c_userId: {
      immediate: true,
      handler() {
        this.$axios.defaults.headers.common["_id"] = this.c_userId;
        window.axios.defaults.headers.common["_id"] = this.c_userId;
      },
    },
    c_token: {
      immediate: true,
      handler() {
        this.$axios.defaults.headers.common["Authorization"] = this.c_token;
        window.axios.defaults.headers.common["Authorization"] = this.c_token;
      },
    },
  },
};
</script>

<style scoped>
.v-toolbar {
  max-height: 64px;
}
.router {
  height: 100%;
}
.fullHeight {
  height: 100%;
}
.contain {
  object-fit: "contain";
}
>>> .v-image__image {
  background-position: left center !important;
}
.weather {
  flex-direction: row;
  display: flex;
}
.logo-alignment {
  padding-left: 5%;
  padding-right: 5%;
}
.time {
  display: flex;
  align-self: center;
}
</style>
